import { z } from 'zod';
import { passwordSetupBodySchema, passwordSetupCheckBodySchema, } from '../../auth/set-password-form.js';
/**
 * An added Account User setting their own password from the link in their
 * verification email (users-and-permissions `technical.md`, Setting a
 * password). Both routes are `@PublicRoute()`: the person has no session yet.
 * Each is limited per client IP before the body is checked
 * (`patterns/auth-patterns.md`, 1).
 */
/**
 * `valid` gives back only the address the link already names. Every link that
 * can't be used — expired, forged, already used, a removed Account User's — is
 * `invalid`, with nothing else.
 */
export const passwordSetupCheckResponseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('valid'), email: z.email() }),
    z.object({ status: z.literal('invalid'), email: z.null() }),
]);
export const checkPasswordSetup = {
    method: 'POST',
    path: '/api/dashboard/password-setup-checks',
    params: z.object({}),
    query: z.object({}),
    body: passwordSetupCheckBodySchema,
    response: passwordSetupCheckResponseSchema,
};
/**
 * Sets the password, verifies the address and signs the person in: `204` with
 * the new session's cookie. `422 VALIDATION_FAILED` on `password` for its
 * length, or on `token` when the link can't be used.
 */
export const setUpPassword = {
    method: 'POST',
    path: '/api/dashboard/password-setups',
    params: z.object({}),
    query: z.object({}),
    body: passwordSetupBodySchema,
    response: z.void(),
};
//# sourceMappingURL=password-setups.js.map